import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, StringDecoder } from "@simonbackx/simple-encoding";
import { SimpleError } from "@simonbackx/simple-errors";
import { v4 as uuidv4 } from "uuid";
export var Country;
(function (Country) {
    Country["Belgium"] = "BE";
})(Country || (Country = {}));
export class CountryHelper {
    static getName(country) {
        switch (country) {
            case Country.Belgium: return "België";
        }
    }
}
export class Address extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.street = "";
        this.number = "";
        this.postalCode = "";
        this.city = "";
        this.country = Country.Belgium;
    }
    get valid() {
        return this.street !== '' && this.city !== '' && this.postalCode !== '' && this.number !== '';
    }
    static createFromFields(addressLine1, postalCode, city, country) {
        const { street, number } = Address.splitAddressLine(addressLine1);
        if (postalCode.length == 0) {
            throw new SimpleError({
                code: "invalid_field",
                message: "Postal code missing",
                human: "Vul een postcode in",
                field: "postalCode"
            });
        }
        if (city.length == 0) {
            throw new SimpleError({
                code: "invalid_field",
                message: "City missing",
                human: "Vul een gemeente in",
                field: "city"
            });
        }
        return Address.create({
            street,
            number,
            postalCode: postalCode,
            city: city,
            country: country
        });
    }
    static splitAddressLine(addressLine1) {
        if (addressLine1.length == 0) {
            throw new SimpleError({
                code: "invalid_field",
                message: "Empty address line 1",
                human: "Vul een straat en huisnummer in"
            });
        }
        const match = /^\s*([^0-9]+?)[\s,]*([0-9].*?)\s*$/.exec(addressLine1);
        if (!match) {
            throw new SimpleError({
                code: "invalid_field",
                message: "Missing number",
                human: "Het huisnummer ontbreekt na de straatnaam",
                field: "addressLine1"
            });
        }
        const number = match[2];
        const street = match[1];
        return {
            number,
            street
        };
    }
    toString() {
        return this.street + " " + this.number + ", " + this.postalCode + " " + this.city + ", " + CountryHelper.getName(this.country);
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Address.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Address.prototype, "street", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Address.prototype, "number", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Address.prototype, "postalCode", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Address.prototype, "city", void 0);
__decorate([
    field({ decoder: new EnumDecoder(Country) })
], Address.prototype, "country", void 0);
//# sourceMappingURL=Address.js.map